import { render, staticRenderFns } from "./MajorCheckList.vue?vue&type=template&id=4f6216e4&"
import script from "./MajorCheckList.vue?vue&type=script&lang=js&"
export * from "./MajorCheckList.vue?vue&type=script&lang=js&"
import style0 from "./MajorCheckList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!///node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports